import BaseModelAPI from '../BaseModelAPI';

export default class Dies extends BaseModelAPI {
	static entity = 'dies';
	static entityName = 'dies';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.diesLong = '';
			this.wide = '';
			this.height = '';
			this.standarPreventive = '';
			this.uomId = '';
			this.uom = {};
			this.remark = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}